import {Component, ElementRef, Input} from '@angular/core';
import {kanUsersService} from "../../../../services/services/users";
import {User} from "../../../../../classes/user";
import {MatDialog, PageEvent} from "@angular/material";
import {kanUserDialog} from "../../../dialogs/user-dialog/component";
import {kanAuthService} from "../../../../services/services/auth";
import * as XLSX from 'xlsx';

@Component({
    selector: 'kan-users',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    providers: [kanUsersService]
})
export class kanUsers {

    @Input() selectedTab: number;
    public loading: boolean = false;
    public users: User[] = [];
    public filteredUsers: User[] = [];
    public pagedUsers: User[] = [];
    public search: string = '';
    public sortBy: string = 'name';
    public sortByOptions: any[] = [
        {
            title: 'NAME',
            field: 'name'
        },
        {
            title: 'SURNAME',
            field: 'surname'
        },
        {
            title: 'CITY',
            field: 'city'
        }];
    public sortDirection: string = 'ASC';
    public sortDirections: string[] = ['ASC', 'DESC'];
    public members: boolean = false;
    public pageIndex: number = 0;
    public pageSize: number = 20;
    public totalUsers: number = 0;
    public filter: any = {
        where: {
            and: [
                {
                    role: 'USER',
                    active: true
                }
            ]
        },
        include: ['dogs', 'godfather'],
        order: `${this.sortBy} ${this.sortDirection}`,
        skip: 0,
        limit: 20
    };
    public timeout: any;

    constructor(private element: ElementRef,
                private dialog: MatDialog,
                private authService: kanAuthService,
                private userService: kanUsersService) {
    }

    ngOnInit(): void {

    }

    ngOnChanges(changes): void {
        if (changes.selectedTab.currentValue === 0) {
            this.getUsers();
        }
    }

    get role(): string {
        return this.authService.role;
    }

    public newUserDialog(event: any) {
        let dialogRef = this.dialog.open(kanUserDialog, {
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'add') {
                this.getUsers();
            }
        });
    }

    public getUsers(): void {

        this.loading = true;
        this.userService
            .getUsers({
                where: {active: true},
                include: ['godfather', 'dogs']
            })
            .then((users) => {
                this.users = users;
                this.loading = false;
                this.filterUsers();
            })
            .catch((error) => {
                console.log(error);
                this.loading = false;
            });
    }

    public changePage(event: PageEvent) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.filter.skip = this.pageIndex * this.pageSize;
        this.filter.limit = this.pageSize;
        this.filterUsers();
    }

    public filterUsers(resetPage: boolean = false) {

        if (resetPage) {
            this.pageIndex = 0;
            this.filter.skip = this.pageIndex * this.pageSize;
            this.filter.limit = this.pageSize;
        }

        this.filteredUsers = this.users
            .filter((item) => {

                if (this.members && !(item.dogs || []).some(dog => dog.membershipActive)) {
                    return false;
                }

                if (this.search) {
                    let textArray = this.search
                        .replace(/\s+/g, ' ')
                        .trim()
                        .split(' ');

                    for (let i = 0; i < textArray.length; i++) {
                        let partialFound = this.handleize(item.email || '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.name || '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.surname || '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.address || '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.city || '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.cp || '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.phone || '').includes(this.handleize(textArray[i])) ||
                            this.handleize((item.dogs || []).map(dog => dog.name).join(' ')).includes(this.handleize(textArray[i])) ||
                            this.handleize(item.godfather ? item.godfather.name || '' : '').includes(this.handleize(textArray[i])) ||
                            this.handleize(item.godfather ? item.godfather.surname || '' : '').includes(this.handleize(textArray[i]));

                        if (!partialFound) return false;
                    }
                    return true;
                } else {
                    return true;
                }
            })
            .sort((item1, item2) => {
                switch (this.sortBy) {
                    case 'name':
                        if (this.sortDirection === 'ASC') return this.handleize(item1.name || '') < this.handleize(item2.name || '') ?
                            -1 : this.handleize(item1.name || '') > this.handleize(item2.name || '') ? 1 : 0;
                        else return this.handleize(item1.name || '') > this.handleize(item2.name || '') ?
                            -1 : this.handleize(item1.name || '') < this.handleize(item2.name || '') ? 1 : 0;
                    case 'surname':
                        if (this.sortDirection === 'ASC') return this.handleize(item1.surname || '') < this.handleize(item2.surname || '') ?
                            -1 : this.handleize(item1.surname || '') > this.handleize(item2.surname || '') ? 1 : 0;
                        else return this.handleize(item1.surname || '') > this.handleize(item2.surname || '') ?
                            -1 : this.handleize(item1.surname || '') < this.handleize(item2.surname || '') ? 1 : 0;
                    case 'city':
                        if (this.sortDirection === 'ASC') return this.handleize(item1.city || '') < this.handleize(item2.city || '') ?
                            -1 : this.handleize(item1.city || '') > this.handleize(item2.city || '') ? 1 : 0;
                        else return this.handleize(item1.city || '') > this.handleize(item2.city || '') ?
                            -1 : this.handleize(item1.city || '') < this.handleize(item2.city || '') ? 1 : 0;
                    default:
                        return 0;
                }
            });

        this.pageUsers();
    }

    public pageUsers() {
        this.pagedUsers = this.filteredUsers.slice(this.filter.skip, this.filter.skip + this.filter.limit)
    }

    public handleize(text = '') {
        return text.toString().toLowerCase()
            .replace(/[áàäâ]/g, 'a')
            .replace(/[éèëê]/g, 'e')
            .replace(/[íìïî]/g, 'i')
            .replace(/[óòöô]/g, 'o')
            .replace(/[úùüû]/g, 'u');
            // .replace(/[^\w\-]+/g, '');
    }

    public exportXlsx() {

        let users = this.users.map((item) => {
            return {
                email: item.email,
                name: item.name,
                surname: item.surname,
                gender: item.gender,
                phone: item.phone,
                dni: item.dni,
                birthday: item.birthday,
                cp: item.cp,
                city: item.city,
                address: item.address,
                membershipNumber: item.membershipNumber,
                membershipActive: item.membershipActive,
                firstContact: item.firstContact,
                emailing: item.emailing,
                agree: item.agree
            };
        });

        let worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(users);
        let workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};

        XLSX.writeFile(workbook, `users_export_${new Date().getTime()}.xlsx`);
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/user/users/component.ts